/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyDescriptionRequest {
    getFixupPrototypeFunction() { return PolicyDescriptionRequest.fixupPrototype; }

    static newInstance(model: Partial<PolicyDescriptionRequest>): PolicyDescriptionRequest {
        let obj = Object.assign(new PolicyDescriptionRequest(), model);
        PolicyDescriptionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyDescriptionRequest>): PolicyDescriptionRequest {
        if (!model) return null;
        return PolicyDescriptionRequest.newInstance(<PolicyDescriptionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyDescriptionRequest) {
        if (!obj) return;

        models.PolicyDescriptionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyDescriptionRequest): boolean {
        Object.setPrototypeOf(obj, PolicyDescriptionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Unique URI for policy
     */
    policy_uris: Array<string>;

}
